/**
 * Regla 11/09 (Arturo): "paso 0 de todo smoke = confirmar el build en pantalla"
 * — ningún re-smoke vuelve a ser ambiguo sobre QUÉ código corre. El id se
 * hornea al BUILD (vite define): SHA corto de Railway, o marca local en dev.
 * Visible en la pantalla de bloqueo y en Configuración → Piso y PINs.
 */
declare const __BUILD_ID__: string;

export const BUILD_ID: string = typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'dev';
